export default "__VITE_ASSET__65a76702__"